import React from "react";
import { useNavigate } from "react-router";
import { markInternalNavigation } from "@/utils/attributionCapture";

const CifFalloutPage = ({ data }) => {
  const navigate = useNavigate();
  return (
    <div className="container text-center mt50">
      <img
        src="/assets/images/hubzu-logo.png"
        alt="Hubzu Logo"
        srcset=""
        className="logo-edit-cif"
      />
      <p className="link-expired-cif">
        {data?.step === "CI_COMPLETED" ? (
          <>
            Sorry, the link has expired. Please check your registered mail as we
            have already sent the Purchase and Sale agreement for you to proceed
            with the contract processing.
          </>
        ) : (
          <>Sorry! this link is not active anymore.</>
        )}
      </p>
      <button
        className="btn btn-thm mt-3 fw-normal"
        onClick={() => { markInternalNavigation(); navigate("/auctions?listingType=AUCN"); }}
      >
        CONTINUE YOUR SEARCH
      </button>
    </div>
  );
};

export default CifFalloutPage;
